require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[44],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "@keyframes ba-common-progressIndicator_bar_before{0%{left:-100%}100%{left:0}}@keyframes ba-common-progressIndicator_bar_after{0%{left:0}100%{left:100%}}.is-bar{background-color:#e0e0e0;width:100%;height:4px;position:relative;overflow:hidden;outline:1px solid transparent}.is-bar .ba-common-progressIndicator__determinateFiller{border-width:4px;border-style:solid}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller{border-style:none;width:50%;border-color:#0f62fe}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:before,.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:after{position:absolute;animation:ba-common-progressIndicator_bar_after 1s linear infinite;content:\"\";width:50%;border-width:4px;border-style:solid;border-color:#0f62fe}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:before{animation:ba-common-progressIndicator_bar_before 1s linear infinite}", ""]);

// exports


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-carbon-tooltip-popup__container{user-select:none;font-weight:normal;font-size:11px;line-height:13px;position:absolute;z-index:999999;max-width:160px;text-align:center;min-height:20px;pointer-events:none}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box{min-width:100px;max-width:160px;position:absolute;pointer-events:none;height:inherit}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{min-width:100px;max-width:160px;width:max-content;padding:8px;font-weight:600;font-size:12px;display:inline-block;border:1px solid transparent;background-color:#393939;color:#fff;box-shadow:0 2px 8px 0 rgba(0,0,0,.1);position:relative;line-height:16px;overflow-wrap:break-word;word-wrap:break-word}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content::after{clear:all}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box{transform:translateX(-50%) translateY(-100%) translateY(-8px)}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box{transform:translateX(-50%) translateY(8px)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box{transform:translateX(-8px) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{float:right}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box{transform:translateX(8px) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{float:left}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{content:\"\";position:absolute;margin-top:-5px;border-width:5px;border-style:solid;bottom:0;left:50%;transform:translateX(-50%) translateY(100%)}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{content:\"\";position:absolute;margin-top:-5px;border-width:5px;border-style:solid;top:0;left:50%;transform:translateX(-50%) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{content:\"\";position:absolute;margin-top:-5px;border-width:5px;border-style:solid;right:0;top:50%;-webkit-transform:translateX(100%);transform:translateX(100%)}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{content:\"\";position:absolute;margin-top:-5px;border-width:5px;border-style:solid;left:0;top:50%;transform:translateX(-100%)}.ba-common-carbon-tooltip-popup__container{transition:opacity .2s ease-in-out,transform .2s ease-in-out}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box{background-color:#343334;color:#fff;box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{border-color:#343334 transparent transparent transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{border-color:#fff #000 #000 #000}}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{border-color:transparent #343334 transparent transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #fff #000 #000}}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{border-color:transparent transparent #343334 transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #000 #fff #000}}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{border-color:transparent transparent transparent #343334}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #000 #000 #fff}}", ""]);

// exports
exports.locals = {
	"tooltipPopupClassName": "\"ba-common-carbon-tooltip-popup\""
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tooltip{position:relative}.ba-common-tooltip [disabled]{pointer-events:none}.ba--highContrast .ba-common-tooltip__container:before{border-style:none}", ""]);

// exports
exports.locals = {
	"tooltipClassName": "\"ba-common-tooltip\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(431);


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ProgressIndicator = _interopRequireDefault(__webpack_require__(432));

exports.default = _ProgressIndicator.default;
exports.ProgressIndicator = _ProgressIndicator.default;

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = exports.DEFAULT_DELAY = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _baUiCarbon = __webpack_require__(9);

var _Tooltip = _interopRequireDefault(__webpack_require__(76));

__webpack_require__(433);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  BaPropTypes,
  sanitize
} = _utils.propsUtils;
const DEFAULT_DELAY = 250;
exports.DEFAULT_DELAY = DEFAULT_DELAY;

class ProgressIndicator extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_inlineRender", () => {
      const {
        status,
        iconDescription,
        onSuccess
      } = this.props.inlineOptions;

      if (this.context.pureCarbon) {
        return /*#__PURE__*/_react.default.createElement(_baUiCarbon.InlineLoading, this.props);
      }

      const inlineProps = {
        status,
        description: this.props.description,
        iconDescription,
        onSuccess
      };
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.InlineLoading, (0, _extends2.default)({}, this._getProgressProps(), inlineProps));
    });
    (0, _defineProperty2.default)(this, "_circleRender", () => {
      const {
        size,
        withOverlay,
        active,
        description
      } = this.props;
      const circleProps = {
        small: size === 'small' || size === 'normal',
        withOverlay,
        active,
        description
      };
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Loading, (0, _extends2.default)({}, this._getProgressProps(), circleProps));
    });
  }

  _isDeterminate() {
    return this.props.progress != null;
  }

  _getProgressProps() {
    const {
      tabIndex,
      className,
      style,
      ...others
    } = this.props;
    const props = { ...sanitize(others, ProgressIndicator),
      tabIndex: tabIndex === 0 ? 0 : null,
      role: 'progressbar',
      className,
      style
    };
    return props;
  }

  _barRender() {
    const {
      variant,
      className
    } = this.props;
    const classNames = (0, _utils.classnames)(className, variant);
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      id: "tooltip-bottom",
      title: this._isDeterminate() ? `${this.props.progress}%` : 'indeterminate',
      disabled: !this._isDeterminate(),
      orient: "bottom",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, this._getProgressProps(), {
      className: classNames
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "ba-common-progressIndicator__determinateFiller"
    })));
  }

  render() {
    const {
      variant
    } = this.props;
    return this[`_${variant}Render`]();
  }

}

(0, _defineProperty2.default)(ProgressIndicator, "propTypes", {
  /** If the element can be focused witht the tab key */
  tabIndex: _propTypes.default.oneOf([-1, 0]),

  /** Choose from fixed sizes */
  variant: _propTypes.default.oneOf(['circle', 'bar', 'inline']),

  /** Choose from fixed sizes */
  size: _propTypes.default.oneOf(['small', 'normal', 'large']),

  /** ( Temporarily deprecated ) Used when determinate is true to indicate progress stage */
  progress: BaPropTypes.range(0, 100),

  /** Specify an description that would be used to best describe the loading state */
  description: _propTypes.default.string,

  /** Custom class name(s) */
  className: _propTypes.default.string,

  /** Custom CSS styles */
  style: _propTypes.default.object,

  /** ( Temporarily deprecated ) Display progress updates */
  determinate: _propTypes.default.bool,

  /** Specify whether you want the loading indicator to be spinning or not */
  active: _propTypes.default.bool,

  /** Specify whether you want the loader to be applied with an overlay */
  withOverlay: _propTypes.default.bool,

  /** Additional props (status, iconDescription, onSuccess) for inline varirant */
  inlineOptions: _propTypes.default.shape({
    status: _propTypes.default.oneOf(['inactive', 'active', 'finished', 'error']),
    iconDescription: _propTypes.default.string,

    /** Optional callback function to be invoked when complete  */
    onSuccess: _propTypes.default.func
  })
});
(0, _defineProperty2.default)(ProgressIndicator, "defaultProps", {
  tabIndex: -1,
  size: 'normal',
  determinate: false,
  variant: 'circle',
  description: '',
  className: '',
  style: {},
  active: true,
  withOverlay: false
});

var _default = (0, _utils.delayMount)(DEFAULT_DELAY)(ProgressIndicator);

exports.default = _default;

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_ProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _utils = __webpack_require__(5);

var _TooltipPopup = _interopRequireDefault(__webpack_require__(77));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  sanitize
} = _utils.propsUtils;

const tooltipPopupClassName = _TooltipPopup.default.tooltipPopupClassName.replace(/"/g, '');

const {
  resolveBaseTextDir
} = _utils.bidiUtils;

class TooltipPopup extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._box = node;
    });
    this.tooltip = document.createElement('div');
    this.state = {
      isIE: window.navigator.userAgent.indexOf('Edge') > -1 || !!window.MSInputMethodContext && !!document.documentMode
    };
  }

  componentDidMount() {
    document.body.appendChild(this.tooltip);

    this._updatePosition();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.availableSpace !== this.props.availableSpace) {
      this._updatePosition();
    }
  }

  componentWillUnmount() {
    document.body.removeChild(this.tooltip);
  }

  _updatePosition() {
    if (this.props.availableSpace) {
      this.newOrient = _utils.domUtils.autoPosition(this.props.availableSpace, {
        height: this._box.clientHeight + 10,
        width: this.state.isIE ? 200 : this._box.firstChild.clientWidth
      }, this.props.orient);
    }

    const actualOrient = this.newOrient ? this.newOrient : this.props.orient;

    const tooltipStyle = this._getStyle(this._box.getBoundingClientRect().width, actualOrient);

    this._box.setAttribute('style', `top: ${tooltipStyle.top}px; left: ${tooltipStyle.left}px; min-width: ${this._box.getBoundingClientRect().width}px`);
  }

  _getStyle(tooltipBoxWidth, orient) {
    const orientsList = [(0, _utils.classnames)('top'), (0, _utils.classnames)('right'), (0, _utils.classnames)('bottom'), (0, _utils.classnames)('left')];
    orientsList.map(item => this.tooltip.firstElementChild.classList.remove(item));
    this.tooltip.firstElementChild.classList.add((0, _utils.classnames)(orient));
    const {
      triggerState
    } = this.props;
    let tooltipStyle;

    if (orient === 'left') {
      tooltipStyle = {
        left: -parseInt(tooltipBoxWidth, 10),
        top: parseInt(triggerState.height, 10) / 2
      };
    } else if (orient === 'right') {
      tooltipStyle = {
        left: parseInt(triggerState.width, 10),
        top: parseInt(triggerState.height, 10) / 2
      };
    } else if (orient === 'top') {
      tooltipStyle = {
        top: 0,
        left: parseInt(triggerState.width, 10) / 2
      };
    } else {
      tooltipStyle = {
        top: parseInt(triggerState.height, 10),
        left: parseInt(triggerState.width, 10) / 2
      };
    }

    return tooltipStyle;
  }

  render() {
    const {
      className,
      title,
      triggerState,
      style,
      popupWidth,
      textDir,
      ...others
    } = this.props;
    const containerWidth = this.state.isIE ? Math.min(parseInt(`${window.innerWidth - (triggerState.left || 0)}`, 10), 200) : parseInt(`${triggerState.width || 0}`, 10);
    const tooltipContentProps = {
      className: `${tooltipPopupClassName}__content`
    };

    if (typeof title === 'string') {
      tooltipContentProps.dir = resolveBaseTextDir(title, textDir, false);
    }

    return _reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, TooltipPopup), {
      className: `${tooltipPopupClassName}__container ${className}`,
      style: {
        top: parseInt(`${triggerState.top || 0}`, 10),
        left: parseInt(`${triggerState.left || 0}`, 10),
        width: containerWidth,
        maxWidth: popupWidth,
        ...style
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `${tooltipPopupClassName}__box`,
      ref: this._ref,
      style: {
        minWidth: popupWidth
      }
    }, /*#__PURE__*/_react.default.createElement("div", tooltipContentProps, title))), this.tooltip);
  }

}

exports.default = TooltipPopup;
(0, _defineProperty2.default)(TooltipPopup, "propTypes", {
  orient: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  triggerState: _propTypes.default.object,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  availableSpace: _propTypes.default.object,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  popupWidth: _propTypes.default.string,
  textDir: _propTypes.default.string
});
(0, _defineProperty2.default)(TooltipPopup, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _TooltipPopup = _interopRequireDefault(__webpack_require__(54));

var _Tooltip = _interopRequireDefault(__webpack_require__(78));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const tooltipClassName = _Tooltip.default.tooltipClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const DEFAULT_DELAY_TIME = 800;

class Tooltip extends _react.Component {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "state", {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      hover: false
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      isKey(e, keyNames.ESCAPE) && this.setState({
        hover: false
      }, this._clearTimer);
    });
    (0, _defineProperty2.default)(this, "_onMouseEnter", () => {
      this._resetStates();

      const {
        delay
      } = this.props;
      const newState = {
        hover: true,
        ...(delay ? {
          hidden: true
        } : {})
      };
      document.addEventListener('keydown', this._onKeyDown, false);
      this.setState(newState, delay && this._setTimer);
    });
    (0, _defineProperty2.default)(this, "_onMouseDown", e => {
      const elementOnMouse = document.elementFromPoint && document.elementFromPoint(e.clientX, e.clientY);

      if (elementOnMouse && this.trigger.current !== elementOnMouse) {
        this.setState({
          hover: false
        }, this._clearTimer);
      }
    });
    (0, _defineProperty2.default)(this, "_onMouseLeave", () => {
      this.setState({
        hover: false
      }, this._clearTimer);
    });
    this.handleHashChange = this.handleHashChange.bind(this);
    this.trigger = (0, _react.createRef)();
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange);
  }

  componentWillUnmount() {
    this._clearTimer();

    window.removeEventListener('hashchange', this.handleHashChange);
  }

  handleHashChange() {
    this.setState({
      hover: false
    }, this._clearTimer);
  }

  _setTimer() {
    const {
      delay
    } = this.props;
    let time;

    if (typeof delay === 'number') {
      time = delay;
    } else {
      time = DEFAULT_DELAY_TIME;
    }

    this.timer = setTimeout(() => {
      this.setState({
        hidden: false
      });
    }, time);
  }

  _clearTimer() {
    const {
      delay
    } = this.props;
    document.removeEventListener('keydown', this._onKeyDown, false);

    if (delay && this.timer) {
      clearTimeout(this.timer);
    }
  }

  _resetStates() {
    this.setState({
      top: _utils.domUtils.computeTopWith(this.trigger.current),
      left: _utils.domUtils.computeLeftWith(this.trigger.current),
      width: this.trigger.current.clientWidth,
      height: this.trigger.current.clientHeight,
      availableSpace: _utils.domUtils.availableSpace(this.trigger.current)
    });
  }

  render() {
    // update orient by calling autoposition
    const {
      display,
      orient,
      title,
      children,
      className,
      style,
      disabled,
      popupWidth,
      textDir,
      ...others
    } = this.props;
    const {
      top,
      left,
      width,
      height
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, Tooltip), {
      ref: this.trigger,
      className: `${tooltipClassName} ${className}`,
      style: {
        display,
        ...style
      },
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      onMouseDown: this._onMouseDown
    }), children, title != null && title !== '' && this.state.hover && !this.state.hidden && !disabled && /*#__PURE__*/_react.default.createElement(_TooltipPopup.default, {
      orient: orient,
      title: title,
      textDir: textDir,
      availableSpace: this.state.availableSpace,
      triggerState: {
        top,
        left,
        width,
        height
      },
      popupWidth: popupWidth
    }));
  }

}

exports.default = Tooltip;
(0, _defineProperty2.default)(Tooltip, "propTypes", {
  display: _propTypes.default.oneOf(['block', 'inline-block']),
  orient: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  children: _propTypes.default.node,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  delay: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  style: _propTypes.default.object,

  /** Specifies the width of the tooltip popup */
  popupWidth: _propTypes.default.string
});
(0, _defineProperty2.default)(Tooltip, "defaultProps", {
  orient: 'bottom',
  display: 'inline-block',
  className: '',
  style: {}
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TooltipPopup_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TooltipPopup_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TooltipPopup_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TooltipPopup_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_TooltipPopup_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tooltip_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tooltip_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tooltip_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tooltip_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Tooltip_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[430,0]]]);
});